import axios from "@/plugins/axios";

let url = "/api/console/center/questions";

export const questions = {
    gets(data){
        return axios.get(url, data).then(result => result.data);
    },
    get(data){
        return axios.get(`${url}/${data._id}`).then(result => result.data);
    },
    post(data){
        return axios.post(url, data).then(result => result.data);
    },
    put(data){
        return axios.put(`${url}/${data._id}`, data).then(result => result.data);
    },
    // 삭제는 소프트 삭제 — 서버가 deletedAt·deletedBy 만 기록하고 문서는 남긴다
    delete(data){
        return axios.delete(`${url}/${data._id}`).then(result => result.data);
    },
    // 선택 삭제 — _questions: [_id, ...]
    deleteMany(_questions){
        return axios.post(`${url}/delete`, { _questions }).then(result => result.data);
    }
}
